import {
  ComboBox,
  IComboBox,
  IComboBoxOption,
  IconButton,
  Label,
  Panel,
  PanelType,
  TooltipHost,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import {
  IconButtonStyles,
  emojiIcon,
  hostStyles,
} from "../../utils/helpers/stylesHelper";
import { FormEvent, useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../components/Panel/PanelHeader";
import { useDetallePersona } from "../../hooks/useDetallePersona";
import { PanelFooter } from "../../components/Panel/PanelFooter";
import { useAsignarSupervisor } from "../../hooks/useAsignarSupervisor";
import { IAsignacionSupervisor } from "../../Interfaces/IPersona";
import { useParams } from "react-router-dom";
import { MensajeBar } from "../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../components/generic/IndicadorProgress";
import React from "react";
import personaServicio from "../../services/persona/personaServicio";
import { IResponsePost } from "../../Interfaces/base/IResponse";
import { send } from "process";

interface IAsignarSupervisor {
  disabled: boolean | undefined;
  checked: boolean | undefined;
  supervisor: string | undefined;
  personaId: string | undefined;
  reload?: () => void
}

export const AsignarSupervisor = (props: IAsignarSupervisor) => {

  const { id } = useParams();
  const [dataRequest, setDataRequest] = useState<IAsignacionSupervisor>(null!);
  const [supervisoresCombo, setSupervisoresCombo] = useState<IComboBoxOption[]>([]);
  const [search, setSearch] = useState("");

  //const { getDataListSupervisores, supervisoresCombo } = useDetallePersona();
  //const { _onClickAsignar, response, ocultarMensaje, isSend } = useAsignarSupervisor(setDataRequest);

  const comboBoxRefPersona = React.useRef<IComboBox>(null);
  const _openOptionPersona = React.useCallback(() => comboBoxRefPersona.current?.focus(true), []);

  //const { _onClickAsignar, response, ocultarMensaje, isSend } = useAsignarSupervisor(setDataRequest);

  const [isOpenAsignacion, { setTrue: openAsignacion, setFalse: dismissAsignacion },] = useBoolean(false);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] = useBoolean(false);

  const [response, setResponse] = useState<IResponsePost>(null!);
  const [tipoMensaje, setTipoMensaje] = useState(0);
  const [ocultaBoton, setOcultaBoton] = useState(false);


  useEffect(() => {
    if (isOpenAsignacion) {
      //ComboSupervisorAPI();
      //ocultarMensaje();
      setDataRequest(null!);
    } else {
      setOcultaBoton(false)
    }
  }, [isOpenAsignacion]);



  useEffect(() => {

    if (tipoMensaje === 1) {

      setTimeout(() => {
        setTipoMensaje(0)
        setDataRequest(null!);
        dismissAsignacion()

      }, 2000);

    }

  }, [tipoMensaje])


  useEffect(() => {
    ComboSupervisorAPI(search);
  }, [search]);

  const _onClickAsignar = (data: IAsignacionSupervisor) => {
    //ocultarMensaje()
    onEnviar();
    personaServicio
      .asignarSupervisor(data)
      .then((res) => {
        if (res.status === 200) {
          setResponse(res.data);
          onCancelar();
          setTipoMensaje(1)
          setOcultaBoton(true)
          props.reload!()
        }
      })
      .catch((e: Error) => {
        setResponse({ mensaje: e.message, codigoMensaje: 3 });
        //onCancelar();
      });
  };


  const ComboSupervisorAPI = (search: string) => {
    personaServicio
      .getSupervisoresIPERCdigital(search)
      .then((res) => {
        let d: any[] = res.data;
        let op: IComboBoxOption[] = [];
        d.map((val) => {
          op.push({
            key: val.supervisorId,
            text: val.doi + " | " + val.fullName,
          });
        });
        setSupervisoresCombo(op);
      })
      .catch((e: Error) => { });
  };

  const onChangeComboBox = (
    event: FormEvent<IComboBox>,
    option: IComboBoxOption | undefined,
    nombre: string
  ) => {
    if (event !== undefined) {
      if (option) {
        switch (nombre) {
          case "supervisor":


            if (id !== undefined) {
              let aux: string[] = [];
              aux.push(id);

              setDataRequest({
                ...dataRequest,
                personaId: aux,
                supervisorId: option?.key.toString(),
              });

            }
            break;
          default:
            break;
        }
      }
    }
  };

  const _onUpPersona = (ev?: React.KeyboardEvent<IComboBox>) => {
    _openOptionPersona();
    let { value } = ev?.target as HTMLInputElement;
    console.log(value);
    setSearch(value);
  }

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="AddFriend"
          subTextHeader="Administración Supervisor"
          textHeader="Asignación de Supervisor"
        />
      </>
    ),
    []
  );

  const onRenderFooter = useCallback(
    () => (
      <>

        {!ocultaBoton && (
          <div>
            <PanelFooter
              onClick={() => {
                _onClickAsignar(dataRequest);
              }}
              onDismiss={dismissAsignacion}
            />
          </div>
        )}

      </>
    ),
    [dismissAsignacion, _onClickAsignar]
  );

  return (
    <>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-depth-8 ms-fontColor-themePrimary--hover">
        <br />
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <div className="ms-Grid-col ms-sm11 ms-md11 ms-lg11">
            <Label>Supervisor: {props.supervisor} </Label>
            <br />
          </div>
          <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1">
            <TooltipHost
              content="Asigna supervisor"
              id="tooltip"
              styles={hostStyles}
            >
              <IconButton
                iconProps={emojiIcon}
                aria-label="Emoji"
                disabled={props.disabled}
                checked={props.checked}
                styles={IconButtonStyles}
                onClick={openAsignacion}
              />
            </TooltipHost>
          </div>
        </div>
      </div>
    
      <Panel
        isOpen={isOpenAsignacion}
        onDismiss={dismissAsignacion}
        onRenderHeader={onRenderHeader}
        onRenderFooter={onRenderFooter}
        isFooterAtBottom={true}
        type={PanelType.medium}

      >
        <>
          {tipoMensaje === 1 && (
            <div>
              <MensajeBar
                response={response}
                ocultar={() => {
                  //ocultarMensaje();
                }}
              />
            </div>
          )}

          {isSend == true ? (
            <IdicadorProgress isSend={isSend} subText="Espere un momento..." />
          ) : (
            <>
              <br />
              {/*    <ComboBox
                label="Supervisor:"
                defaultSelectedKey="C"
                options={supervisoresCombo}
                selectedKey={dataRequest?.supervisorId}
                placeholder="Seleccionar Supervisor"
                useComboBoxAsMenuWidth
                styles={{ optionsContainer: { maxHeight: 300 } }}
                onChange={(event, option) => {
                  onChangeComboBox(event, option, "supervisor");
                }}
              /> */}

              {/*   <pre>{JSON.stringify(dataRequest, null, 2)}</pre> */}

              <ComboBox
                componentRef={comboBoxRefPersona}
                placeholder="Seleccionar Supervisor"
                label="Supervisor:"
                allowFreeform
                useComboBoxAsMenuWidth
                calloutProps={{ directionalHintFixed: true }}
                options={supervisoresCombo}
                onKeyUp={_onUpPersona}
                styles={{ optionsContainer: { maxHeight: 300 } }}
                selectedKey={dataRequest ? dataRequest?.supervisorId : null}
                onChange={(event, option) => { onChangeComboBox(event, option, "supervisor") }}
              />
            </>
          )}
        </>
      </Panel>
    </>
  );
};
